import { createMetaDef } from '@exodus/asset'

import tokensParams from './tokens.js'

const name = 'bsc'
const displayName = 'BNB'
const ticker = 'BNBBSC'
const displayTicker = 'BNB'
const displayNetworkTicker = 'BSC'
const displayNetworkName = 'BNB Smart Chain'
const primaryColor = '#FFB700'
const gradientColors = ['#FFB700', '#D8AC29']
const gradientCoords = { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' }
const chainBadgeColors = ['#D9AF3D', '#E8C353']
const chainId = 56

const gasLimit = 21e3 // enough to send ETH to a normal address
const contractGasLimit = 1e6 // used when estimateGas fails

const units = {
  wei: 0,
  Kwei: 3,
  Mwei: 6,
  Gwei: 9,
  szabo: 12,
  finney: 15,
  BNBBSC: 18,
}

const assetType = 'ETHEREUM_LIKE'
const tokenAssetType = 'BSC_BEP20'
const blockExplorer = {
  addressUrl: (address) => `https://bscscan.com/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://bscscan.com/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'BNB Smart Chain (BSC) is an innovative solution to bring programmability and interoperability to Beacon Chain. The BNB Smart Chain also supports EVM-compatible smart contracts and protocols. Cross-chain transfer and other communication are possible due to native support of interoperability. ',
  reddit: 'https://www.reddit.com/r/binance/',
  twitter: 'https://www.twitter.com/binance',
  website: 'https://www.binance.com/',
  telegram: 'https://t.me/BinanceExchange',
}

const assetParams = {
  assetType,
  blockExplorer,
  chainBadgeColors,
  chainId,
  contractGasLimit,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gasLimit,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  ticker,
  tokenAssetType,
  units,
}

const tokenOverrides = (token) => ({
  ...token,
  blockExplorer: {
    ...token.blockExplorer,
    addressUrl: (address) =>
      `https://bscscan.com/token/${encodeURIComponent(token.addresses.current)}?a=${encodeURIComponent(address)}`,
  },
  contract: token.addresses,
  gasLimit: 120e3,
})

export const { asset, tokens, assetsList } = createMetaDef({
  assetParams,
  tokensParams,
  tokenOverrides,
})

export default assetsList
